import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';

/**
 * Displays paid QR passport sponsor ads inside the Bar Passport.
 * Rotates through active advertisers.
 */
export default function MedullaSponsorSlot() {
  const [ads, setAds] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    axios.get(`${API}/medulla/serve/qr`).then(res => {
      setAds(res.data.ads || []);
      // Track impression on first ad
      if (res.data.ads?.length) {
        axios.post(`${API}/medulla/track/${res.data.ads[0].campaign_id}/impression`).catch(() => {});
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (ads.length < 2) return;
    const t = setInterval(() => {
      setIdx(i => {
        const next = (i + 1) % ads.length;
        axios.post(`${API}/medulla/track/${ads[next].campaign_id}/impression`).catch(() => {});
        return next;
      });
    }, 10000);
    return () => clearInterval(t);
  }, [ads]);

  if (!ads.length) return null;
  const ad = ads[idx];

  const handleClick = () => {
    axios.post(`${API}/medulla/track/${ad.campaign_id}/click`).catch(() => {});
    window.open(ad.click_url, '_blank', 'noopener');
  };

  return (
    <div data-testid="medulla-sponsor-slot"
      className="my-4 p-3 bg-gradient-to-br from-zinc-900 to-black border border-green-500/30 rounded-lg cursor-pointer hover:border-green-500/60 transition"
      onClick={handleClick}
    >
      <div className="flex items-center gap-3">
        {ad.image_url && (
          <img src={ad.image_url} alt="" className="w-16 h-16 object-cover rounded" />
        )}
        <div className="flex-1 min-w-0">
          <div className="text-[10px] font-mono text-green-400 tracking-widest mb-1">SPONSORED</div>
          <h4 className="text-sm font-bold text-white truncate">{ad.title}</h4>
          {ad.description && <p className="text-xs text-zinc-400 line-clamp-2">{ad.description}</p>}
          <span className="text-xs text-green-400 mt-1 inline-block">{ad.cta_text} →</span>
        </div>
      </div>
    </div>
  );
}
